// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Z8Ta","col":"CardReaderDesc_col__1QGS6","label":"CardReaderDesc_label__1PBM-"};